import { render } from "./EmailListTable.vue?vue&type=template&id=88c713a4"
import script from "./EmailListTable.vue?vue&type=script&lang=js"
export * from "./EmailListTable.vue?vue&type=script&lang=js"
script.render = render

export default script